module.exports = __webpack_public_path__ + "medical_type_ico_1.svg?a208db004b1fc304920798a55937c565";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/medical_type_ico_1.svg
// module id = 107
// module chunks = 0